import React, { useState, useEffect } from "react";
import { MdDragIndicator } from "react-icons/md";
import Loader from "components/Common/loader";

function TableRow({ row, index, moveRow, prepareRow, getRowProps }) {
  prepareRow(row);
  const rowProps = getRowProps(row.original) || {};
  const { key, ...restRowProps } = row.getRowProps();

  const [isDragging, setIsDragging] = useState(false);

  return (
    <tr
      key={key}
      {...restRowProps}
      draggable
      onDragStart={(e) => {
        setIsDragging(true);
        e.dataTransfer.setData("rowIndex", index);
      }}
      onDragEnd={() => setIsDragging(false)}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        const fromIndex = parseInt(e.dataTransfer.getData("rowIndex"), 10);
        moveRow(fromIndex, index);
      }}
      style={{ cursor: "grab", opacity: isDragging ? 0.6 : 1 }}
    >
      {row.cells.map((rowCell, cellIndex) => {
        const { key, ...cellProps } = rowCell.getCellProps();
        return (
          <td key={key} {...cellProps} style={{ position: "relative" }}>
            {/* {isDragging ? "📌" : rowCell.render("Cell")} */}
            {cellIndex === 0 && (
              <span
                style={{
                  cursor: "grab",
                  display: "inline-flex",
                  alignItems: "center",
                  marginRight: "8px",
                  color: "#888",
                }}
              >
                <MdDragIndicator size={20} />
              </span>
            )}
            {rowCell.render("Cell")}
          </td>
        );
      })}
    </tr>
  );
}

function DragTableContainer({
  headerGroups,
  getTableBodyProps,
  rows,
  getTableProps,
  prepareRow,
  isLoading = false,
  getRowProps = () => ({}),
  totalRecords,
  tableData,
  onRowsReordered,
}) {
  const [tableRows, setTableRows] = useState(rows);

  useEffect(() => {
    setTableRows(rows);
  }, [rows]);

  // const moveRow = (fromIndex, toIndex) => {
  //   setTableRows((prevRows) => {
  //     let updatedRows = [...prevRows];

  //     if (fromIndex !== toIndex) {
  //       const draggedRow = updatedRows.splice(fromIndex, 1)[0]; // Remove row
  //       updatedRows.splice(toIndex, 0, draggedRow); // Insert row at new position
  //     }

  //     updatedRows = updatedRows.map((row, index) => ({
  //       ...row,
  //       original: { ...row.original, _index: index + 1 },
  //       _index: index + 1,
  //     }));

  //     setTimeout(() => {
  //       onRowsReordered([...updatedRows]);
  //     }, 0);

  //     return updatedRows;
  //   });
  // };

  const moveRow = (fromIndex, toIndex) => {
    setTableRows((prevRows) => {
      let updatedRows = [...prevRows];

      if (fromIndex !== toIndex) {
        const temp = updatedRows[fromIndex];
        updatedRows[fromIndex] = updatedRows[toIndex];
        updatedRows[toIndex] = temp;
      }

      updatedRows = updatedRows.map((row, index) => ({
        ...row,
        original: { ...row.original, _index: index + 1 },
        _index: index + 1,
      }));

      setTimeout(() => {
        onRowsReordered([...updatedRows]);
      }, 0);

      return [...updatedRows];
    });
  };

  return (
    <>
      <div className="boxContent noPadding">
        <div className="contentScroll">
          {isLoading && <Loader isLoading={true} isFixed={false} />}
          <table className="table mb-0 table-hover" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => {
                const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                return (
                  <tr key={key} {...headerGroupProps}>
                    {headerGroup.headers.map((column) => {
                      const { key, ...cellProps } = column.getHeaderProps(column.getSortByToggleProps());
                      return (
                        <th key={key} {...cellProps}>
                          {column.render("Header")}
                        </th>
                      );
                    })}
                  </tr>
                );
              })}
            </thead>
            <tbody {...getTableBodyProps()}>
              {tableRows.map((row, index) => (
                <TableRow
                  key={row.id}
                  row={row}
                  index={index}
                  moveRow={moveRow}
                  prepareRow={prepareRow}
                  getRowProps={getRowProps}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {!isLoading && totalRecords === 0 && (
        <div className="noData">No data found</div>
      )}
      {!isLoading && tableData?.length === 0 && (
        <div className="noData">No data found</div>
      )}
    </>
  );
}

export default DragTableContainer;
